import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';

import { isLoggedInUserRoot } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { upgradeMembers } from '../../../../store/actions/paragonProcessActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';
import { ToggleLockingMenuItem } from '../shared-menu-items/ToggleLockingMenuItem';

export function MembersContainerMenu() {
  const dispatch = useAppDispatch();
  const monitor = useAppMonitor();

  const isRoot = useAppSelector(isLoggedInUserRoot);
  const componentDesign = useAppSelector(getActiveComponentDesign);

  if (componentDesign == null) return null;

  return (
    <SceneMenuContent>
      <AddItemMenuItem type="member" />

      {isRoot && (
        <SceneMenuItem
          text="Upgrade Members"
          icon={<RefreshIcon />}
          disabled={componentDesign == null}
          onClick={() => {
            dispatch(upgradeMembers(componentDesign));
            monitor.recordInteraction('Members => Upgrade Members menu item clicked');
          }}
        />
      )}

      <ToggleLockingMenuItem type="member" context="container" />
    </SceneMenuContent>
  );
}
